"use client"

import { useState, useEffect, useRef } from "react"
import { Button } from "react-bootstrap"
import Select from "react-select"
import { useNavigate, useParams, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import countryStateCity from "./countriesStatesCities.json"
import { getPatientlistbygenderAction } from "../../../../store/actions/PatientsAction"
import {
  createLeadAction,
  updateLeadAction,
  addLeadAddressInfoAction,
  addLeadOtherInfoAction,
  addleadMarriageInfoAction,
  getLeadDetailsAction,
} from "../../../../store/actions/LeadAction.js"
import { getDiseasesAction } from "../../../../store/actions/DiseasesAction"
import Loader from "../../Common/Loader.jsx"
import { showErrorAlert, handleSuccess } from "../../../../services/ErrorHandlingService.js"

const initialFormState = {
  first_name: "",
  middle_name: "",
  last_name: "",
  date_of_birth: "",
  whatsapp_contact_no: "",
  additional_contact_no: "",
  patient_email: "",
  weight: "",
  height: "",
  id_proof: "",
  id_number: "",
  disease_names: [],
  gender: "",
  occupation: "",
  lead_photo: "",

  // Marriage info
  maritalStatus: "No",
  marriageEntries: [
    {
      marriageHistory: "1st",
      marriageDate: "",
      spouseOption: "",
      spouseName: "",
      spouseMobile: "",
      spouseEmail: "",
      spouseDOB: "",
      spouseGender: "",
      spouseDetails: "",
      spouseOccupation: "", // Added spouseOccupation
    },
  ],

  // Address info
  tempAddressLine1: "",
  tempAddressLine2: "",
  tempArea: "",
  tempCountry: "",
  tempState: "",
  tempCity: "",
  tempPincode: "",
  useTempAddress: false,
  addressLine1: "",
  addressLine2: "",
  area: "",
  country: "",
  state: "",
  city: "",
  pincode: "",
  callConduct: "",

  // Other info
  adName: "",
  adSet: "",
  campaignName: "",
  leadSource: "",
  lead_status: "",
  lead_type: "",
  modifiedBy: "",
  userType: "",
  branch: "",
  treatmentHistory: "",
  comment: "",
}

const formatPatientsForDropdown = (patients) => {
  if (!Array.isArray(patients)) return []

  return patients.map((patient) => ({
    value: patient.patient_id,
    label: (patient.patient_name || "").trim(),
  }))
}

const AddLead = () => {
  const { id: leadId } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [formData, setFormData] = useState(initialFormState)
  const [countries, setCountries] = useState([])
  const [errors, setErrors] = useState({})
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [permCountries, setPermCountries] = useState([])
  const [permStates, setPermStates] = useState([])
  const [permCities, setPermCities] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [fetching, setFetching] = useState(false)

  const diseases = useSelector((state) => state.diseases.diseases || [])

  const leadDetails = useSelector((state) => state.leadState?.leadDetails)
  const fieldRefs = useRef({})
  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/
    return phoneRegex.test(phone.replace(/\D/g, ""))
  }

  const validatePincode = (pincode) => {
    const pincodeRegex = /^[0-9]{6}$/
    return pincodeRegex.test(pincode)
  }

  const validateIdNumber = (idProof, idNumber) => {
    if (!idNumber) return false

    switch (idProof) {
      case "PAN":
        return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idNumber)
      case "Aadhar":
        return /^[0-9]{12}$/.test(idNumber.replace(/\s/g, ""))
      case "Driving License":
        return idNumber.length >= 8 && idNumber.length <= 20
      default:
        return idNumber.length > 0
    }
  }

  const validateForm = () => {
    const newErrors = {}

    // First Name
    if (!formData.first_name?.trim()) {
      newErrors.first_name = "First name is required"
    } else if (formData.first_name.trim().length < 2) {
      newErrors.first_name = "First name must be at least 2 characters"
    } else if (!/^[a-zA-Z\s]+$/.test(formData.first_name.trim())) {
      newErrors.first_name = "First name should contain only letters"
    }

    // Last Name
    if (!formData.last_name?.trim()) {
      newErrors.last_name = "last name is required"
    } else if (formData.last_name.trim().length < 2) {
      newErrors.last_name = "last name must be at least 2 characters"
    } else if (!/^[a-zA-Z\s]+$/.test(formData.last_name.trim())) {
      newErrors.last_name = "last name should contain only letters"
    }

    // Email
    if (formData.patient_email) {
      if (!validateEmail(formData.patient_email)) {
        newErrors.patient_email = "Please enter a valid email address"
      }
    }

    // WhatsApp Contact No
    if (!formData.whatsapp_contact_no?.trim()) {
      newErrors.whatsapp_contact_no = "WhatsApp contact number is required"
    } else if (!validatePhone(formData.whatsapp_contact_no)) {
      newErrors.whatsapp_contact_no = "Please enter a valid 10-digit phone number"
    }
    if (formData.additional_contact_no && !validatePhone(formData.additional_contact_no)) {
      newErrors.additional_contact_no = "Please enter a valid 10-digit phone number"
    }

    if (formData.pincode && !validatePincode(formData.pincode)) {
      newErrors.pincode = "Please enter a valid 6-digit pincode"
    }

    if (formData.id_proof && formData.id_number) {
      // if (!validateIdNumber(formData.id_proof, formData.id_number)) {
      //   newErrors.id_number = "Invalid ID number for selected ID proof";
      // }
    }

    if (!formData.disease_names || !Array.isArray(formData.disease_names) || formData.disease_names.length === 0) {
      newErrors.disease_names = "At least one disease must be selected"
    }
    // gender
    if (!formData.gender) {
      newErrors.gender = "Gender is required"
    }

    // Other Info validations
    // if (!formData.adName?.trim()) {
    //   newErrors.adName = "Ad name is required"
    // }

    // if (!formData.adSet?.trim()) {
    //   newErrors.adSet = "Ad set is required"
    // }

    // if (!formData.campaignName?.trim()) {
    //   newErrors.campaignName = "Campaign name is required"
    // }
// Ad Name validation (NOT required)
if (formData.adName?.trim()) {
  if (formData.adName.trim().length < 3) {
    newErrors.adName = "Ad name must be at least 3 characters";
  }
}

// Ad Set validation (NOT required)
if (formData.adSet?.trim()) {
  if (formData.adSet.trim().length < 2) {
    newErrors.adSet = "Ad set must be at least 2 characters";
  }
}

// Campaign Name validation (NOT required)
if (formData.campaignName?.trim()) {
  if (formData.campaignName.trim().length < 3) {
    newErrors.campaignName = "Campaign name must be at least 3 characters";
  }
}

    if (!formData.leadSource?.trim()) {
      newErrors.leadSource = "Lead source is required"
    }

    if (!formData.lead_status?.trim()) {
      newErrors.lead_status = "Status is required"
    }

    if (!formData.lead_type?.trim()) {
      newErrors.lead_type = "Lead Type is required"
    }

    // Optional: Lead Photo - validate only if file exists
    if (formData.lead_photo) {
      const allowedTypes = ["image/jpeg", "image/png"]
      const allowedExtensions = [".jpg", ".jpeg", ".png"]
      const maxSizeMB = 2

      const file = formData.lead_photo

      // Case 1: New file upload (File object)
      if (typeof file === "object") {
        const fileName = file.name?.toLowerCase() || ""
        const fileExtension = fileName.substring(fileName.lastIndexOf("."))

        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension)

        if (!isValidType) {
          newErrors.lead_photo = "Only JPG or PNG files are allowed"
        } else if (file.size > maxSizeMB * 1024 * 1024) {
          newErrors.lead_photo = "Image must be less than 2MB"
        }
      }

      // Case 2: Existing image from API (string URL)
      else if (typeof file === "string") {
        const lowerUrl = file.toLowerCase()
        const hasValidExtension = allowedExtensions.some((ext) => lowerUrl.endsWith(ext))

        if (!hasValidExtension) {
          newErrors.lead_photo = "Only JPG or PNG files are allowed"
        }
      }
    }
    if (formData.height !== "" && (formData.height < 1 || formData.height > 300)) {
      newErrors.height = "Height must be between 1 and 300 cm"
    }

    if (formData.weight !== "" && (formData.weight < 1 || formData.weight > 200)) {
      newErrors.weight = "Weight must be between 1 and 200 kg"
    }
    // ✅ Marriage Info Validation
    // ✅ Marriage Info Validation
    if (formData.maritalStatus === "Yes" && Array.isArray(formData.marriageEntries)) {
      formData.marriageEntries.forEach((entry, index) => {
        // Marriage Date
        if (!entry.marriageDate?.trim()) {
          newErrors[`marriageDate_${index}`] = "Please enter the date of marriage."
        }

        // Spouse Option
        if (!entry.spouseOption) {
          newErrors[`spouseOption_${index}`] = "Please select whether spouse is with or without."
        }

        // 🟢 WITH SPOUSE VALIDATION
      //   if (entry.spouseOption === "withSpouse") {
      //     // Spouse Details
      //     if (!entry.spouseDetails) {
      //       newErrors[`spouseDetails_${index}`] = "Please select spouse details from patients list."
      //     }

      //     // Spouse Name
      // if (!/^[A-Za-z\s]+$/.test(entry.spouseName.trim())) {
      //       newErrors[`spouseName_${index}`] = "Enter a valid name (letters only)."
      //     }

      //     // Spouse Mobile
      //   if (!/^[0-9]{10}$/.test(entry.spouseMobile)) {
      //       newErrors[`spouseMobile_${index}`] = "Enter a valid 10-digit mobile number."
      //     }

      //     const email = entry.spouseEmail?.trim();

      //     if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      //       newErrors[`spouseEmail_${index}`] = "Enter a valid email address.";
      //     }
          

      //  {
      //       const today = new Date()
      //       const dob = new Date(entry.spouseDOB)
      //       if (dob > today) {
      //         newErrors[`spouseDOB_${index}`] = "Date of birth cannot be in the future."
      //       }
      //     }

      //     // Spouse Gender
      //     if (!entry.spouseGender) {
      //       newErrors[`spouseGender_${index}`] = "Please select spouse gender."
      //     }
      //     if (entry.spouseOccupation?.trim()) {
      //      if (!/^[A-Za-z\s]+$/.test(entry.spouseOccupation.trim())) {
      //         newErrors[`spouseOccupation_${index}`] = "Occupation should contain only letters."
      //       }
      //     }
      //   }
      if (entry.spouseOption === "withSpouse") {

        // ❌ Spouse Details (Not Required)
        // Validate ONLY if user selects something
        if (entry.spouseDetails) {
          // no extra validation needed since it's just a selected value
        }
      
        // ❌ Spouse Name (Not Required)
   
      
        // ❌ Spouse Mobile (Not Required)
        if (entry.spouseMobile?.trim()) {
          if (!/^[0-9]{10}$/.test(entry.spouseMobile)) {
            newErrors[`spouseMobile_${index}`] = "Enter a valid 10-digit mobile number.";
          }
        }
      
        // ❌ Spouse Email (Not Required)
        const email = entry.spouseEmail?.trim();
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          newErrors[`spouseEmail_${index}`] = "Enter a valid email address.";
        }
      
        // ❌ Spouse DOB (Not Required)
        if (entry.spouseDOB) {
          const today = new Date();
          const dob = new Date(entry.spouseDOB);
          if (dob > today) {
            newErrors[`spouseDOB_${index}`] = "Date of birth cannot be in the future.";
          }
        }
      
        // ❌ Spouse Gender (Not Required)
        if (entry.spouseGender?.trim()) {
          // no more validation needed, basic selection OK
        }
      
        // ❌ Spouse Occupation (Not Required)
        if (entry.spouseOccupation?.trim()) {
          if (!/^[A-Za-z\s]+$/.test(entry.spouseOccupation.trim())) {
            newErrors[`spouseOccupation_${index}`] = "Occupation should contain only letters.";
          }
        }
      }
      
        // 🟡 WITHOUT SPOUSE VALIDATION
        if (entry.spouseOption === "withoutSpouse") {
          // Validate ONLY if user typed something
          if (entry.spouseName.trim() !== "" && !/^[A-Za-z\s]+$/.test(entry.spouseName.trim())) {
            newErrors[`spouseName_${index}`] = "Enter a valid name (letters only).";
          }
        }
        
      })
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors) // ✅ update state so error messages show

      // Scroll to first error
      const firstErrorKey = Object.keys(newErrors)[0]
      const errorEl = fieldRefs.current[firstErrorKey]
      if (errorEl?.scrollIntoView) {
        errorEl.scrollIntoView({ behavior: "smooth", block: "center" })
      }

      return false
    }

    setErrors({}) // clear errors if valid
    return true
  }

  const handleChangeWithValidation = (e) => {
    const { name, value, type } = e.target

   
      setFormData((prev) => ({
        ...prev,
        [name]: value === "" ? "" : value, // keep text/email as string
    }))

    // Clear error for this field if user typed
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[name]
        return newErrors
      })
    }
  }

  const clearSpouseFieldError = (index, fieldName) => {
    const errorKey = `${fieldName}_${index}`
    if (errors[errorKey]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[errorKey]
        return newErrors
      })
    }
  }

  // Fetch lead details when ID is available
  useEffect(() => {
    if (leadId) {
      setIsLoading(true)
      dispatch(getLeadDetailsAction(leadId)).finally(() => setIsLoading(false))
    }
  }, [dispatch, leadId])
  useEffect(() => {
    if (
      leadId &&
      formData.gender &&
      formData.marriageEntries?.[0]?.spouseOption === "withSpouse"
    ) {
      dispatch(getPatientlistbygenderAction(formData.gender))
    }
  }, [leadId, formData.gender, dispatch])
  
  // Fixed: Populate form data when lead details are available
  useEffect(() => {
    if (leadDetails && leadId) {
      setFetching(true)
      setErrors({})
      console.log("Lead Details received:", leadDetails)

      const {
        first_name,
        middile_name, // Note: API returns "middile_name" not "middle_name"
        last_name,
        phone_no, // API returns phone_no, not whatsapp_contact_no
        additional_contact_no,
        email,
        lead_photo,
        date_of_birth,
        height,
        weight,
        occupation,
        id_proof,
        id_number,
        gender,
        diseases,
        MarriageInfo, // Note: Capital M
        TemporaryAddress,
        PermanentAddress,
        ad_name, // Direct fields from API response
        adset_name,
        campaign_name,
        lead_source,
        lead_status,
        lead_type,
        comment,
        call_conduct
      } = leadDetails

      // Format date properly
      const formatDateForInput = (dateString) => {
        if (!dateString) return ""
        // If date is in DD-MM-YYYY format, convert to YYYY-MM-DD for input
        if (dateString.includes("-")) {
          const parts = dateString.split("-")
          if (parts.length === 3) {
            // Check if it's DD-MM-YYYY or YYYY-MM-DD
            if (parts[0].length === 4) {
              return dateString // Already in YYYY-MM-DD format
            } else {
              return `${parts[2]}-${parts[1]}-${parts[0]}` // Convert DD-MM-YYYY to YYYY-MM-DD
            }
          }
        }
        return dateString
      }

      setFormData({
        lead_id: leadId,
        first_name: first_name || "",
        middle_name: middile_name || "", // Fixed field name
        last_name: last_name || "",
        whatsapp_contact_no: phone_no || "", // Fixed field mapping
        additional_contact_no: additional_contact_no || "",
        patient_email: email || "", // Fixed field mapping
        date_of_birth: formatDateForInput(date_of_birth),
        lead_photo: lead_photo,
        height: !height || height === "0" ? "" : height,
        weight: !weight || weight === "0" ? "" : weight,
        occupation: occupation || "",
        id_proof: id_proof || "",
        id_number: id_number || "",
        gender: gender || "",

        // Fixed disease mapping
        disease_names: diseases?.length > 0 ? diseases.map((d) => String(d.disease_id)) : [],

        // Fixed marriage info mapping
        maritalStatus: MarriageInfo?.length > 0 ? "Yes" : "No",
        marriageEntries:
          MarriageInfo?.length > 0
            ? MarriageInfo.map((info) => ({
                marriageHistory: info.marriage_history || "1st",
                marriageDate: info.date_of_marriage || "",
                spouseOption: info.spouse_option === "Without Spouse" ? "withoutSpouse" : "withSpouse",
                spouseName: info.husband_or_spouse_name || "",
                spouseMobile: info.spouse_mobile || "",
                spouseEmail: info.spouse_email || "",
                spouseDOB: info.spouse_dob || "",
                spouseGender: info.spouse_gender || "",
                spouseOccupation: info.spouse_occupation || "",
                spouseDetails: info.spouse_details
                ? String(info.spouse_details)
                : null,
              
              }))
            : initialFormState.marriageEntries,

        // Fixed address mapping
        tempAddressLine1: TemporaryAddress?.address_line1 || "",
        tempAddressLine2: TemporaryAddress?.address_line2 || "",
        tempArea: TemporaryAddress?.area || "",
        tempCity: TemporaryAddress?.city || "",
        tempCountry: TemporaryAddress?.country || "",
        tempState: TemporaryAddress?.state || "",
        tempPincode: TemporaryAddress?.pincode || "",

        addressLine1: PermanentAddress?.address_line1 || "",
        addressLine2: PermanentAddress?.address_line2 || "",
        area: PermanentAddress?.area || "",
        city: PermanentAddress?.city || "",
        state: PermanentAddress?.state || "",
        country: PermanentAddress?.country || "",
        pincode: PermanentAddress?.pincode || "",
        useTempAddress: false,

        callConduct: call_conduct || "",
        // Fixed other info mapping - using direct fields from API response
        adName: ad_name || "",
        adSet: adset_name || "",
        campaignName: campaign_name || "",
        leadSource: lead_source || "",
        lead_status: lead_status || "",
        lead_type: lead_type || "",
        comment: comment || "",
        modifiedBy: "",
        userType: "",
        treatmentHistory: "",
      })
      setFetching(false)
    }
  }, [leadDetails, leadId])
  useEffect(() => {
    if (formData.useTempAddress) {
      setFormData((prev) => ({
        ...prev,
        addressLine1: prev.tempAddressLine1,
        addressLine2: prev.tempAddressLine2,
        area: prev.tempArea,
        country: prev.tempCountry,
        state: prev.tempState,
        city: prev.tempCity,
        pincode: prev.tempPincode,
      }))
    }
  }, [
    formData.useTempAddress,
    formData.tempAddressLine1,
    formData.tempAddressLine2,
    formData.tempArea,
    formData.tempCountry,
    formData.tempState,
    formData.tempCity,
    formData.tempPincode,
  ])

  const occupations = [
    "Doctor",
    "Nurse",
    "Engineer",
    "Teacher",
    "Farmer",
    "Housewife",
    "Student",
    "Businessman",
    "Driver",
    "Electrician",
    "Plumber",
    "Carpenter",
    "Lawyer",
    "Police Officer",
    "Artist",
    "Actor",
    "Scientist",
    "Retired",
    "Unemployed",
    "Other",
  ]

  const occupationOptions = occupations.map((occ) => ({
    label: occ,
    value: occ,
  }))
  // Reset form when switching between add/edit modes
  useEffect(() => {
    if (!leadId) {
      setFormData(initialFormState)
    }
  }, [leadId])

  useEffect(() => {
    dispatch(getDiseasesAction(false))
  }, [dispatch])

  // Load countries
  useEffect(() => {
    const countryList = countryStateCity.map((country) => ({
      value: country.name,
      label: country.name,
    }))
    setCountries(countryList)
    setPermCountries(countryList)
  }, [])

  // Load states based on temp country
  useEffect(() => {
    if (formData.tempCountry) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.tempCountry)
      setStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || [],
      )
    } else {
      setStates([])
    }
  }, [formData.tempCountry])

  // Load cities based on temp state
  useEffect(() => {
    if (formData.tempCountry && formData.tempState) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.tempCountry)
      const selectedState = selectedCountry?.states?.find((s) => s.name === formData.tempState)
      setCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || [],
      )
    } else if (formData.tempCity && formData.tempCity !== "0") {
      setCities([{ value: formData.tempCity, label: formData.tempCity }])
    } else {
      setCities([])
    }
  }, [formData.tempCountry, formData.tempState, formData.tempCity])

  // Load states based on permanent country
  useEffect(() => {
    if (formData.country) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.country)
      setPermStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || [],
      )
    } else {
      setPermStates([])
    }
  }, [formData.country])

  // Load cities based on permanent state
  useEffect(() => {
    if (formData.country && formData.state) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.country)
      const selectedState = selectedCountry?.states?.find((s) => s.name === formData.state)
      setPermCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || [],
      )
    } else if (formData.city && formData.city !== "0") {
      setPermCities([{ value: formData.city, label: formData.city }])
    } else {
      setPermCities([])
    }
  }, [formData.country, formData.state, formData.city])

  useEffect(() => {
    return () => {
      setFormData(initialFormState)
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const validTypes = ["image/jpeg", "image/jpg", "image/png"]
      if (!validTypes.includes(file.type)) {
        showErrorAlert("Please select a JPEG or PNG image.")
        return
      }

      setFormData((prev) => ({
        ...prev,
        lead_photo: file,
      }))
    }
  }

  const handleMarriageEntryChange = (index, e) => {
    const { name, value } = e.target

    setFormData((prev) => ({
      ...prev,
      marriageEntries: prev.marriageEntries.map((entry, i) => (i === index ? { ...entry, [name]: value } : entry)),
    }))

    clearSpouseFieldError(index, name)
  }

  const addMarriageEntry = () => {
    const newIndex = formData.marriageEntries.length
    const newEntry = {
      marriageHistory: `${newIndex + 1}${getOrdinalSuffix(newIndex + 1)}`,
      marriageDate: "",
      spouseOption: "",
      spouseDetails: "",
      spouseName: "",
      // spouseMobile: "", // Added spouseMobile
      // spouseEmail: "", // Added spouseEmail
      // spouseDOB: "", // Added spouseDOB
      // spouseGender: "", // Added spouseGender
      // spouseOccupation: "", // Added spouseOccupation
    }

    setFormData((prev) => ({
      ...prev,
      marriageEntries: [...prev.marriageEntries, newEntry],
    }))
  }

  const deleteMarriageEntry = (index) => {
    if (formData.marriageEntries.length <= 1) return

    const updatedEntries = formData.marriageEntries.filter((_, i) => i !== index)

    const reOrdered = updatedEntries.map((entry, i) => ({
      ...entry,
      marriageHistory: `${i + 1}${getOrdinalSuffix(i + 1)}`,
    }))

    setFormData((prev) => ({
      ...prev,
      marriageEntries: reOrdered,
    }))
  }

  const getOrdinalSuffix = (n) => {
    const s = ["th", "st", "nd", "rd"],
      v = n % 100
    return s[(v - 20) % 10] || s[v] || s[0]
  }

  const calculateMarriageAge = (marriageDate) => {
    if (!marriageDate) return ""

    const today = new Date()
    const marriage = new Date(marriageDate)

    if (isNaN(marriage.getTime())) return ""

    let years = today.getFullYear() - marriage.getFullYear()
    let months = today.getMonth() - marriage.getMonth()
    let days = today.getDate() - marriage.getDate()

    // Adjust months and years if current day is before marriage day
    if (days < 0) {
      months--
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0)
      days += prevMonth.getDate() // Add days from the previous month
    }

    if (months < 0) {
      years--
      months += 12
    }

    const weeks = Math.floor(days / 7)

    const parts = []
    if (years > 0) parts.push(`${years} y${years > 1 ? "" : ""}`)
    if (months > 0) parts.push(`${months} m${months > 1 ? "" : ""}`)
    if (weeks > 0) parts.push(`${weeks} w${weeks > 1 ? "" : ""}`)

    return parts.join(", ") || "0 weeks"
  }

  const formatMarriageEntriesForAPI = (entries) => {
    return entries.map((entry) => {
      const withSpouse = entry.spouseOption === "withSpouse"
      return {
        marriageNumber: entry.marriageHistory,
        dateOfMarriage: entry.marriageDate,
        withSpouse: withSpouse.toString(),
        spouseName: withSpouse ? "" : entry.spouseName, // Empty if withSpouse is false
        marriageAge: calculateMarriageAge(entry.marriageDate).toString(),
        spouse_name: withSpouse ? entry.spouseName ?? "" : "",
        spousedetails: withSpouse ? entry.spouseDetails : "", // Use null if not withSpouse
        spouse_mobile: withSpouse ? entry.spouseMobile ?? "" : "",
        spouse_email: withSpouse ? entry.spouseEmail ?? "" : "",
        spouse_dob: withSpouse ? entry.spouseDOB ?? "" : "",
        spouse_gender: withSpouse ? entry.spouseGender ?? "" : "",
        spouse_occupation: withSpouse ? entry.spouseOccupation ?? "" : "",
      }
    })
  }

  const idProofOptions = [
    { value: "PAN", label: "PAN" },
    { value: "Aadhar", label: "Aadhar" },
    { value: "Driving License", label: "Driving License" },
  ]
  const callConductOptions = [
    { value: "Direct Call", label: "Direct Call" },
    { value: "Online", label: "Online" },
    { value: "Campaign", label: "Campaign" },
  ];
  
  
  const patients = useSelector((state) => state.patients.patients || [])
  const patientOptions = formatPatientsForDropdown(patients)

  // const handleGenderChange = (selectedOption) => {
  //   const gender = selectedOption.value;

  //   setFormData((prev) => ({
  //     ...prev,
  //     gender: gender,
  //   }));
  //   dispatch(getPatientlistbygenderAction(gender));
  // };
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Transgender", label: "Transgender" },
  ]

  const handleGenderChange = (selectedOption) => {
    const gender = selectedOption?.value || ""

    // ✅ Update form data
    setFormData((prev) => ({
      ...prev,
      gender,
    }))

    if (gender && errors.gender) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors.gender
        return newErrors
      })
    }

    if (gender) {
      dispatch(getPatientlistbygenderAction(gender))
    }
  }

  const handleSelectChange = (selectedOption, index) => {
    setFormData((prevFormData) => {
      const updatedEntries = [...prevFormData.marriageEntries]
      updatedEntries[index] = {
        ...updatedEntries[index],
        spouseDetails: selectedOption ? selectedOption.value : "",
      }
      return {
        ...prevFormData,
        marriageEntries: updatedEntries,
      }
    })

    // Clear spouseDetails error on selection
    clearSpouseFieldError(index, "spouseDetails")
  }

  const handleTextDateChange = (e) => {
    const { value } = e.target
    setFormData((prev) => ({
      ...prev,
      date_of_birth: value, // Keep the date in YYYY-MM-DD format for the input
    }))
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   // setIsLoading(true);
  //   // setErrors({});
  //   if (isLoading) return
  //   setIsLoading(true)
  //   setErrors({})
  //   if (!validateForm()) {
  //     setIsLoading(false)
  //     return
  //   }

  //   // setIsLoading(true)

  //   try {
  //     const submitData = {
  //       ...formData,
  //       disease_ids: JSON.stringify(
  //         Array.isArray(formData.disease_names)
  //           ? formData.disease_names
  //           : formData.disease_names
  //             ? [formData.disease_names]
  //             : [],
  //       ),
  //     }
  //     console.log("submit data:", submitData)

  //     console.log("Disease IDs being sent as JSON string:", submitData.disease_ids)
  //     console.log("Input data for lead:", submitData)

  //     let resultLeadId

  //     if (leadId) {
  //       submitData.lead_id = leadId
  //       await dispatch(updateLeadAction(submitData))
  //       resultLeadId = leadId
  //     } else {
  //       const result = await dispatch(createLeadAction(submitData))
  //       resultLeadId = result?.lead_id
  //     }

  //     if (!resultLeadId) {
  //       throw new Error("Lead operation failed")
  //     }

  //     console.log("Lead ID:", resultLeadId)

  //     // Add marriage info if married
  //     const formattedMarriageData = formatMarriageEntriesForAPI(formData.marriageEntries)
  //     console.log("Sending to API MARRIAGE:", JSON.stringify(formattedMarriageData))

  //     await dispatch(
  //       addleadMarriageInfoAction({
  //         lead_id: resultLeadId,
  //         is_married: formData.maritalStatus,
  //         marriage_entries: formData.maritalStatus === "Yes" ? formattedMarriageData : null,
  //       }),
  //     )

  //     // Add address info
  //     const temporary_address = {
  //       addressLine1: formData.tempAddressLine1 || "",
  //       addressLine2: formData.tempAddressLine2 || "",
  //       area: formData.tempArea || "",
  //       city: formData.tempCity || "",
  //       state: formData.tempState || "",
  //       country: formData.tempCountry || "",
  //       pincode: formData.tempPincode || "",
  //     }

  //     const permanent_address = {
  //       addressLine1: formData.addressLine1 || "",
  //       addressLine2: formData.addressLine2 || "",
  //       area: formData.area || "",
  //       city: formData.city || "",
  //       state: formData.state || "",
  //       country: formData.country || "",
  //       pincode: formData.pincode || "",
  //       useTemporaryAsPermanent: formData.useTempAddress,
  //     }

  //     console.log("temporary_address JSON:", JSON.stringify(temporary_address))
  //     console.log("permanent_address JSON:", JSON.stringify(permanent_address))

  //     await dispatch(
  //       addLeadAddressInfoAction({
  //         lead_id: resultLeadId,
  //         temporary_address: JSON.stringify(temporary_address),
  //         permanent_address: JSON.stringify(permanent_address),
  //       }),
  //     )

  //     // Add Other info
  //     await dispatch(
  //       addLeadOtherInfoAction({
  //         lead_id: resultLeadId,
  //         ad_name: formData.adName,
  //         ad_Set: formData.adSet,
  //         campaign_name: formData.campaignName,
  //         lead_source: formData.leadSource,
  //         lead_status: formData.lead_status,
  //         lead_type: formData.lead_type,
  //         modified_by: formData.modifiedBy,
  //         user_type: formData.userType,
  //         treatment_history: formData.treatmentHistory,
  //         comment: formData.comment,
  //         call_conduct: formData.callConduct,

  //       }),
  //     )

  //     handleSuccess(`Lead successfully ${leadId ? "updated" : "created"}!`)

  //     setTimeout(() => {
  //       if (!leadId) {
  //         setFormData(initialFormState)
  //         navigate("/app-leads", { replace: true })
  //       }
  //     }, 1000)
  //   } catch (error) {
  //     console.error("Lead operation error:", error)
  //     showErrorAlert(`Failed to ${leadId ? "update" : "create"} lead: ${error.message}`)
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }
  const handleSubmit = async (e) => {
    e.preventDefault()
  
    if (isLoading) return
    setIsLoading(true)
    setErrors({})
  
    if (!validateForm()) {
      setIsLoading(false)
      return
    }
  
    try {
      const submitData = {
        ...formData,
        disease_ids: JSON.stringify(
          Array.isArray(formData.disease_names)
            ? formData.disease_names
            : formData.disease_names
            ? [formData.disease_names]
            : [],
        ),
      }
  
      // ✅ IMPORTANT: Use existing lead_id if available
      const effectiveLeadId =
        leadId || formData.lead_id || sessionStorage.getItem("draftLeadId")
  
      let resultLeadId
  
      // ==========================
      // 1️⃣ CREATE OR UPDATE LEAD
      // ==========================
      if (effectiveLeadId) {
        submitData.lead_id = effectiveLeadId
        await dispatch(updateLeadAction(submitData))
        resultLeadId = effectiveLeadId
      } else {
        const result = await dispatch(createLeadAction(submitData))
        resultLeadId = result?.lead_id
  
        if (!resultLeadId) {
          throw new Error("Lead creation failed")
        }
  
        // 🔥 STORE LEAD ID IMMEDIATELY
        setFormData((prev) => ({
          ...prev,
          lead_id: resultLeadId,
        }))
        sessionStorage.setItem("draftLeadId", resultLeadId)
      }
  
      // ==========================
      // 2️⃣ MARRIAGE INFO
      // ==========================
      const formattedMarriageData = formatMarriageEntriesForAPI(
        formData.marriageEntries,
      )
  
      await dispatch(
        addleadMarriageInfoAction({
          lead_id: resultLeadId,
          is_married: formData.maritalStatus,
          marriage_entries:
            formData.maritalStatus === "Yes" ? formattedMarriageData : null,
        }),
      )
  
      // ==========================
      // 3️⃣ ADDRESS INFO
      // ==========================
      const temporary_address = {
        addressLine1: formData.tempAddressLine1 || "",
        addressLine2: formData.tempAddressLine2 || "",
        area: formData.tempArea || "",
        city: formData.tempCity || "",
        state: formData.tempState || "",
        country: formData.tempCountry || "",
        pincode: formData.tempPincode || "",
      }
  
      const permanent_address = {
        addressLine1: formData.addressLine1 || "",
        addressLine2: formData.addressLine2 || "",
        area: formData.area || "",
        city: formData.city || "",
        state: formData.state || "",
        country: formData.country || "",
        pincode: formData.pincode || "",
        useTemporaryAsPermanent: formData.useTempAddress,
      }
  
      await dispatch(
        addLeadAddressInfoAction({
          lead_id: resultLeadId,
          temporary_address: JSON.stringify(temporary_address),
          permanent_address: JSON.stringify(permanent_address),
        }),
      )
  
      // ==========================
      // 4️⃣ OTHER INFO
      // ==========================
      await dispatch(
        addLeadOtherInfoAction({
          lead_id: resultLeadId,
          ad_name: formData.adName,
          ad_Set: formData.adSet,
          campaign_name: formData.campaignName,
          lead_source: formData.leadSource,
          lead_status: formData.lead_status,
          lead_type: formData.lead_type,
          modified_by: formData.modifiedBy,
          user_type: formData.userType,
          treatment_history: formData.treatmentHistory,
          comment: formData.comment,
          call_conduct: formData.callConduct ?? ""

        }),
      )
  
      // ==========================
      // ✅ SUCCESS
      // ==========================
      handleSuccess(
        `Lead successfully ${leadId || formData.lead_id ? "updated" : "created"}!`,
      )
  
      // CLEANUP
      sessionStorage.removeItem("draftLeadId")
  
      setTimeout(() => {
        if (!leadId) {
          setFormData(initialFormState)
          navigate("/app-leads", { replace: true })
        }
      }, 1000)
    } catch (error) {
      console.error("Lead operation error:", error)
      showErrorAlert(
        `Failed to ${leadId || formData.lead_id ? "update" : "create"} lead: ${
          error.message
        }`,
      )
    } finally {
      setIsLoading(false)
    }
  }
  
  const handleBack = () => {
    setFormData(initialFormState)
    navigate(-1)
  }

  const handleDiseasesChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map((opt) => String(opt.value)) : []

    handleChange({
      target: {
        name: "disease_names",
        value: values,
      },
    })

    if (values.length === 0) {
      setErrors((prev) => ({
        ...prev,
        disease_names: "At least one disease must be selected",
      }))
    } else {
      setErrors((prev) => ({
        ...prev,
        disease_names: "",
      }))
    }
  }

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={2000} /> */}
      <div className="row">
        <div className="col-xl-12">
          <div className="d-flex justify-content-end p-3">
            <Link to="/app-leads" className="btn btn-link p-0">
              <Button variant="primary">Back</Button>
            </Link>
          </div>
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["first_name"] = el)}>
                    <label className="form-label">
                      First Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter first name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.first_name && <small className="text-danger">{errors.first_name}</small>}
                  </div>

                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Middle Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter middle name"
                      name="middle_name"
                      value={formData.middle_name}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.middle_name && <small className="text-danger">{errors.middle_name}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["last_name"] = el)}>
                    <label className="form-label">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter last name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.last_name && <small className="text-danger">{errors.last_name}</small>}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["patient_email"] = el)}>
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter lead email"
                      name="patient_email"
                      value={formData.patient_email}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.patient_email && <small className="text-danger">{errors.patient_email}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["whatsapp_contact_no"] = el)}>
                    <label className="form-label">
                      Whatsapp Contact Number
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Whatsapp contact number"
                      name="whatsapp_contact_no"
                      value={formData.whatsapp_contact_no}
                      onChange={handleChangeWithValidation}
                      maxLength="10"
                    />
                    {errors.whatsapp_contact_no && <small className="text-danger">{errors.whatsapp_contact_no}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["additional_contact_no"] = el)}>
                    <label className="form-label">Additional Contact Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter additional contact number"
                      name="additional_contact_no"
                      value={formData.additional_contact_no}
                      onChange={handleChangeWithValidation}
                      maxLength="10"
                    />
                    {errors.additional_contact_no && (
                      <small className="text-danger">{errors.additional_contact_no}</small>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["lead_photo"] = el)}>
                    <label className="form-label">Photo</label>
                    <input type="file" className="form-control" accept=".jpg,.jpeg,.png" onChange={handleFileChange} />

                    {/* Show previous image name if editing and no new file is chosen */}
                    {typeof formData.lead_photo === "string" && (
                      <small className="text-muted mt-1 d-block">
                        Current file: {formData.lead_photo.split("/").pop()}
                      </small>
                    )}

                    {/* Show selected new file name */}
                    {typeof formData.lead_photo === "object" && (
                      <small className="text-muted mt-1 d-block">Selected file: {formData.lead_photo.name}</small>
                    )}

                    {/* Show error if any */}
                    {errors.lead_photo && <small className="text-danger">{errors.lead_photo}</small>}

                    {/* ✅ Image Preview */}
                    {(formData.lead_photo || formData.lead_photo_preview) && (
                      <div className="mt-3 text-center">
                        <img
                          src={
                            typeof formData.lead_photo === "string"
                              ? formData.lead_photo
                              : URL.createObjectURL(formData.lead_photo)
                          }
                          alt="Lead Preview"
                          style={{
                            maxHeight: "150px",
                            borderRadius: "8px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <div className="col-xl-4 mb-3">
                    <label className="form-label">
                      Gender<span style={{ color: "red" }}>*</span>
                    </label>
                    <div ref={(el) => (fieldRefs.current["gender"] = el)}>
                      <Select
                        name="gender"
                        options={[
                          { value: "Male", label: "Male" },
                          { value: "Female", label: "Female" },
                          { value: "Transgender", label: "Transgender" },
                        ]}
                        value={formData.gender ? { value: formData.gender, label: formData.gender } : null}
                        onChange={handleGenderChange}
                        placeholder="Select Gender"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            minHeight: "50px",
                            height: "50px",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            lineHeight: "50px",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: "4px",
                          }),
                          indicatorSeparator: (provided) => ({
                            ...provided,
                            display: "none",
                          }),
                        }}
                      />
                    </div>
                    {errors.gender && <small className="text-danger">{errors.gender}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["date_of_birth"] = el)}>
                    <label className="form-label">Date of Birth</label>
                    <div className="form-group position-relative">
                      <input
                        type="date"
                        className="form-control"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleTextDateChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                      <i
                        className="fa fa-calendar position-absolute"
                        style={{
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          fontSize: "18px",
                          zIndex: 1,
                        }}
                      ></i>
                    </div>
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["height"] = el)}>
                    <label className="form-label">Height (cm)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter height"
                      name="height"
                      value={formData.height === "0" || formData.height === 0 ? "" : formData.height}
                      onChange={handleChangeWithValidation}
                      // min="1"
                      // max="300"
                    />
                    {errors.height && <small className="text-danger">{errors.height}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["weight"] = el)}>
                    <label className="form-label">Weight (kg)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter weight"
                      name="weight"
                      value={formData.weight === "0" || formData.weight === 0 ? "" : formData.weight}
                      onChange={handleChangeWithValidation}
                      // min="1"
                      // max="200"
                    />
                    {errors.weight && <small className="text-danger">{errors.weight}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["occupation"] = el)}>
                    <label className="form-label">Occupation</label>
                    <Select
                      options={occupationOptions}
                      name="occupation"
                      placeholder="Select occupation"
                      isSearchable
                      isClearable
                      value={
                        formData.occupation
                          ? {
                              label: formData.occupation,
                              value: formData.occupation,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFormData({
                          ...formData,
                          occupation: selectedOption ? selectedOption.value : "",
                        })
                      }
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          backgroundColor: "#f0f0f0",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {/* {errors.occupation && (
                      <small className="text-danger">{errors.occupation}</small>
                    )} */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["id_proof"] = el)}>
                    <label className="form-label">ID Proof</label>
                    <Select
                      name="id_proof"
                      options={idProofOptions}
                      value={idProofOptions.find((option) => option.value === formData.id_proof) || null}
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "id_proof",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select ID Proof"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.id_proof && <small className="text-danger">{errors.id_proof}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["id_number"] = el)}>
                    <label className="form-label">ID Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ID number"
                      name="id_number"
                      value={formData.id_number}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.id_number && <small className="text-danger">{errors.id_number}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["disease_names"] = el)}>
                    <label className="form-label">
                      Diseases<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      isMulti
                      options={diseases.map((d) => ({
                        value: String(d.disease_id),
                        label: d.disease_name,
                      }))}
                      value={
                        formData.disease_names?.length > 0
                          ? diseases
                              .filter((d) => formData.disease_names.includes(String(d.disease_id)))
                              .map((d) => ({
                                value: String(d.disease_id),
                                label: d.disease_name,
                              }))
                          : []
                      }
                      onChange={handleDiseasesChange}
                      placeholder="Select Diseases"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          backgroundColor: "#f0f0f0",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.disease_names && <small className="text-danger">{errors.disease_names}</small>}
                  </div>
                </div>

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Marriage Information
                </h6>
                <div className="row mb-3">
                  <div className="col-xl-4 mb-3">
                    <label className="form-label fw-bold">Married</label>
                    <div
                      className="form-check d-flex align-items-center justify-content-start"
                      style={{ height: "40px" }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        id="maritalStatusCheckbox"
                        checked={formData.maritalStatus === "Yes"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            maritalStatus: e.target.checked ? "Yes" : "No",
                          }))
                        }
                      />
                      <label
                        className="form-check-label m-0"
                        htmlFor="maritalStatusCheckbox"
                        style={{ cursor: "pointer" }}
                      >
                        Yes
                      </label>
                    </div>
                  </div>
                </div>

                {formData.maritalStatus === "Yes" && (
                  <div className="marriage">
                    {formData.marriageEntries.map((entry, index) => (
                      <div key={index} className="marriage-entry mb-4 p-3">
                        <div className="row align-items-center mb-3">
                          <div className="col-10">
                            <h6 className="mb-0">Marriage Entry #{index + 1}</h6>
                          </div>
                          <div className="col-2 text-end">
                            {formData.marriageEntries.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deleteMarriageEntry(index)}
                              >
                                <i className="fa fa-trash"></i> Delete
                              </button>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-4 mb-3">
                            <label className="form-label fw-bold">Marriage History</label>
                            <select
                              className="form-select"
                              name="marriageHistory"
                              value={entry.marriageHistory}
                              onChange={(e) => handleMarriageEntryChange(index, e)}
                              style={{ height: "50px" }}
                            >
                              <option value="1st">1st</option>
                              <option value="2nd">2nd</option>
                              <option value="3rd">3rd</option>
                              <option value="4th">4th</option>
                            </select>
                          </div>

                          <div
                            className="col-xl-4 mb-3"
                            ref={(el) => (fieldRefs.current[`marriageDate_${index}`] = el)}
                          >
                            <label className="form-label fw-bold">
                              Date of Marriage
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="marriageDate"
                              value={entry?.marriageDate ?? ""}
                              onChange={(e) => handleMarriageEntryChange(index, e)}
                              max={new Date().toISOString().split("T")[0]}
                              style={{ height: "50px" }}
                            />
                            {errors[`marriageDate_${index}`] && (
                              <small className="text-danger">{errors[`marriageDate_${index}`]}</small>
                            )}
                          </div>

                          {entry.marriageDate && (
                            <div className="col-xl-4 mb-3">
                              <label className="form-label fw-bold">Marriage Age</label>
                              <input
                                type="text"
                                className="form-control"
                                value={calculateMarriageAge(entry.marriageDate)}
                                readOnly
                                style={{
                                  height: "50px",
                                  backgroundColor: "#f8f9fa",
                                }}
                              />
                            </div>
                          )}
                        </div>

                        <div className="row">
                          {/* Spouse Option Selector */}
                          <div className="col-xl-4 mb-3">
                            <label className="form-label fw-bold">Spouse Option</label>
                            <span style={{ color: "red" }}>*</span>
                            <div className="d-flex align-items-center gap-4 mt-2">
                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input me-2"
                                  id={`withSpouse-${index}`}
                                  name={`spouseOption-${index}`}
                                  value="withSpouse"
                                  checked={entry.spouseOption === "withSpouse"}
                                  onChange={() =>
                                    handleMarriageEntryChange(index, {
                                      target: { name: "spouseOption", value: "withSpouse" },
                                    })
                                  }
                                />
                                <label className="form-check-label mb-0" htmlFor={`withSpouse-${index}`}>
                                  With Spouse
                                </label>
                              </div>

                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input me-2"
                                  id={`withoutSpouse-${index}`}
                                  name={`spouseOption-${index}`}
                                  value="withoutSpouse"
                                  checked={entry.spouseOption === "withoutSpouse"}
                                  onChange={() =>
                                    handleMarriageEntryChange(index, {
                                      target: { name: "spouseOption", value: "withoutSpouse" },
                                    })
                                  }
                                />
                                <label className="form-check-label mb-0" htmlFor={`withoutSpouse-${index}`}>
                                  Without Spouse
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ✅ WITH SPOUSE — two + four field layout */}
                        {entry.spouseOption === "withSpouse" && (
                          <>
                            {/* ---- First Row ---- */}
                            <div className="row mt-3">
                              {/* Spouse Details Dropdown */}
                              <div
                                className="col-xl-4 mb-3"
                                ref={(el) => (fieldRefs.current[`spouseDetails_${index}`] = el)}
                              >
                                <label className="form-label fw-bold">
                                  Spouse Details
                                </label>
                                <Select
                                  name={`spouseDetails-${index}`}
                                  options={patientOptions}
                                  value={
                                    entry.spouseDetails
                                      ? patientOptions.find(
                                          (opt) => String(opt.value) === String(entry.spouseDetails)
                                        )
                                      : null
                                  }
                                  
                                  
                                  onChange={(selectedOption) => handleSelectChange(selectedOption, index)}
                                  placeholder="Select Spouse from Patients"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "50px",
                                      height: "50px",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                                {errors[`spouseDetails_${index}`] && (
                                  <small className="text-danger">{errors[`spouseDetails_${index}`]}</small>
                                )}
                              </div>
                        

                              {/* Spouse Mobile */}
                              <div
                                className="col-xl-4 mb-3"
                                ref={(el) => (fieldRefs.current[`spouseMobile_${index}`] = el)}
                              >
                                <label className="form-label fw-bold">Spouse Mobile</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Mobile Number"
                                  name="spouseMobile"
                                  value={entry.spouseMobile || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  maxLength="10"
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseMobile_${index}`] && (
                                  <div className="invalid-feedback d-block">{errors[`spouseMobile_${index}`]}</div>
                                )}
                              </div>

                              {/* Spouse Email */}
                              <div
                                className="col-xl-4 mb-3"
                                ref={(el) => (fieldRefs.current[`spouseEmail_${index}`] = el)}
                              >
                                <label className="form-label fw-bold">Spouse Email</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter Email"
                                  name="spouseEmail"
                                  value={entry.spouseEmail || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseEmail_${index}`] && (
                                  <div className="invalid-feedback d-block">{errors[`spouseEmail_${index}`]}</div>
                                )}
                              </div>
                            </div>

                            {/* ---- Second Row ---- */}
                            <div className="row">
                              {/* Spouse DOB */}
                              <div
                                className="col-xl-4 mb-3 position-relative"
                                ref={(el) => (fieldRefs.current[`spouseDOB_${index}`] = el)}
                              >
                                <label className="form-label fw-bold">Spouse Date of Birth</label>
                                <div className="position-relative">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="spouseDOB"
                                    value={entry.spouseDOB || ""}
                                    onChange={(e) => handleMarriageEntryChange(index, e)}
                                    max={new Date().toISOString().split("T")[0]}
                                    style={{ height: "50px" }}
                                  />
                                  <i
                                    className="fa fa-calendar position-absolute text-muted"
                                    style={{
                                      right: "15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      pointerEvents: "none",
                                      fontSize: "18px",
                                      zIndex: 1,
                                    }}
                                  ></i>
                                </div>
                                {errors[`spouseDOB_${index}`] && (
                                  <div className="invalid-feedback d-block">{errors[`spouseDOB_${index}`]}</div>
                                )}
                              </div>

                              {/* Spouse Gender */}
                              <div
                                className="col-xl-4 mb-3"
                                ref={(el) => (fieldRefs.current[`spouseGender_${index}`] = el)}
                              >
                                <label className="form-label fw-bold">Spouse Gender</label>
                                <Select
                                  name="spouseGender"
                                  value={genderOptions.find((opt) => opt.value === entry.spouseGender) || null}
                                  onChange={(selectedOption) =>
                                    handleMarriageEntryChange(index, {
                                      target: {
                                        name: "spouseGender",
                                        value: selectedOption ? selectedOption.value : "",
                                      },
                                    })
                                  }
                                  options={genderOptions}
                                  placeholder="Select Gender"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: "50px",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                                {errors[`spouseGender_${index}`] && (
                                  <small className="text-danger">{errors[`spouseGender_${index}`]}</small>
                                )}
                              </div>

                              {/* Spouse Occupation */}
                              <div className="col-xl-4 mb-3">
                                <label className="form-label fw-bold">Spouse Occupation</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Occupation"
                                  name="spouseOccupation"
                                  value={entry.spouseOccupation || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseOccupation_${index}`] && (
                                  <small className="text-danger d-block mt-1">
                                    {errors[`spouseOccupation_${index}`]}
                                  </small>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        {/* ✅ WITHOUT SPOUSE — single row with Spouse Name */}
                        {entry.spouseOption === "withoutSpouse" && (
                          <div className="row mt-3">
                                  <div
                              className="col-xl-4 mb-3"
                              ref={(el) => (fieldRefs.current[`spouseName_${index}`] = el)}
                            >
                              <label className="form-label fw-bold">Spouse Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Spouse Name"
                                name="spouseName"
                                value={entry.spouseName || ""}
                                onChange={(e) => handleMarriageEntryChange(index, e)}
                                style={{ height: "50px" }}
                              />
                              {errors[`spouseName_${index}`] && (
                                <div className="invalid-feedback d-block">{errors[`spouseName_${index}`]}</div>
                              )}
                            </div>
                             
                          </div>
                        )}
                      </div>
                    ))}

                    <div className="row mt-3 mb-4">
                      <div className="col-2">
                        <button type="button" className="btn btn-primary" onClick={addMarriageEntry}>
                          <i className="fa fa-plus me-2"></i> Add
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Temporary Address
                </h6>
                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempAddressLine1"] = el)}>
                    <label className="form-label">Address Line 1</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Address Line 1"
                      name="tempAddressLine1"
                      value={formData.tempAddressLine1}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.tempAddressLine1 && <small className="text-danger">{errors.tempAddressLine1}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempAddressLine2"] = el)}>
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Address Line 2"
                      name="tempAddressLine2"
                      value={formData.tempAddressLine2}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.tempAddressLine2 && <small className="text-danger">{errors.tempAddressLine2}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempArea"] = el)}>
                    <label className="form-label">Area</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Area"
                      name="tempArea"
                      value={formData.tempArea}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.tempArea && <small className="text-danger">{errors.tempArea}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempCountry"] = el)}>
                    <label className="form-label">Country</label>
                    <Select
                      name="tempCountry"
                      options={[{ value: "", label: "Select a Country" }, ...countries]}
                      value={
                        formData.tempCountry && formData.tempCountry !== "0"
                          ? countries.find((c) => String(c.value) === String(formData.tempCountry))
                          : null
                      }
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        console.log("Temp Country selected:", value)
                        handleChangeWithValidation({
                          target: {
                            name: "tempCountry",
                            value: value,
                          },
                        })
                      }}
                      placeholder="Select a Country"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.tempCountry && <small className="text-danger">{errors.tempCountry}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempState"] = el)}>
                    <label className="form-label">State</label>
                    <Select
                      name="tempState"
                      options={[{ value: "", label: "Select a State" }, ...states]}
                      value={
                        formData.tempState && formData.tempState !== "0"
                          ? states.find((s) => String(s.value) === String(formData.tempState))
                          : null
                      }
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        console.log("Temp State selected:", value)
                        handleChangeWithValidation({
                          target: {
                            name: "tempState",
                            value: value,
                          },
                        })
                      }}
                      placeholder="Select a State"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.tempState && <small className="text-danger">{errors.tempState}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempCity"] = el)}>
                    <label className="form-label">City</label>
                    <Select
                      name="tempCity"
                      options={[{ value: "", label: "Select a City" }, ...cities]}
                      value={
                        formData.tempCity && formData.tempCity !== "0"
                          ? cities.find((c) => String(c.value) === String(formData.tempCity))
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "tempCity",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      placeholder="Select a City"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.tempCity && <small className="text-danger">{errors.tempCity}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempPincode"] = el)}>
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Pincode"
                      name="tempPincode"
                      value={formData.tempPincode}
                      onChange={handleChangeWithValidation}
                      // pattern="[0-9]{6}"
                      maxLength="6"
                      inputMode="numeric"
                    />
                    {errors.tempPincode && <small className="text-danger">{errors.tempPincode}</small>}
                  </div>
                </div>

                <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                  {/* <input
                    type="checkbox"
                    className="form-check-input m-0"
                    id="useTempAddress"
                    checked={formData.useTempAddress}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setFormData((prevState) => ({
                        ...prevState,
                        useTempAddress: checked,
                        ...(checked
                          ? {
                            addressLine1: prevState.tempAddressLine1,
                            addressLine2: prevState.tempAddressLine2,
                            area: prevState.tempArea,
                            country: prevState.tempCountry,
                            pincode: prevState.tempPincode,
                            city: prevState.tempCity,
                            state: prevState.tempState,
                          }
                          : {
                            addressLine1: "",
                            addressLine2: "",
                            area: "",
                            country: "",
                            state: "",
                            city: "",
                            pincode: "",
                          }),
                      }));
                    }}
                    style={{ marginTop: 0, flexShrink: 0 }}
                  /> */}
                  <input
                    type="checkbox"
                    className="form-check-input m-0"
                    id="useTempAddress"
                    checked={formData.useTempAddress}
                    onChange={(e) => {
                      const checked = e.target.checked

                      setFormData((prevState) => {
                        if (checked) {
                          // When checked → copy temp → perm
                          return {
                            ...prevState,
                            useTempAddress: true,
                            addressLine1: prevState.tempAddressLine1,
                            addressLine2: prevState.tempAddressLine2,
                            area: prevState.tempArea,
                            country: prevState.tempCountry,
                            state: prevState.tempState,
                            city: prevState.tempCity,
                            pincode: prevState.tempPincode,
                          }
                        } else {
                          // When unchecked → stop syncing, but keep current permanent address
                          return {
                            ...prevState,
                            useTempAddress: false,
                          }
                        }
                      })
                    }}
                    style={{ marginTop: 0, flexShrink: 0 }}
                  />

                  <div className="d-flex flex-column justify-content-center">
                    <label className="form-check-label fw-bold mb-0" htmlFor="useTempAddress">
                      Use Temporary Address as Permanent Address
                    </label>
                    {formData.useTempAddress && (
                      <p className="text-muted small mb-0 mt-1">
                        Temporary address will be saved as the permanent address.
                      </p>
                    )}
                  </div>
                </div>

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Permanent Address
                </h6>
                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["addressLine1"] = el)}>
                    <label className="form-label">Address Line 1</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Address Line 1"
                      name="addressLine1"
                      value={formData.addressLine1}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                    />
                    {errors.addressLine1 && <small className="text-danger">{errors.addressLine1}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["addressLine2"] = el)}>
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Address Line 2"
                      name="addressLine2"
                      value={formData.addressLine2}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                    />
                    {errors.addressLine2 && <small className="text-danger">{errors.addressLine2}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["area"] = el)}>
                    <label className="form-label">Area</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Area"
                      name="area"
                      value={formData.area}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                    />
                    {errors.area && <small className="text-danger">{errors.area}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["country"] = el)}>
                    <label className="form-label">Country</label>
                    <Select
                      name="country"
                      options={permCountries}
                      value={permCountries.find((c) => c.value === formData.country) || null}
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        handleChangeWithValidation({
                          target: {
                            name: "country",
                            value,
                          },
                        })
                      }}
                      placeholder="Select a Country"
                      isDisabled={formData.useTempAddress}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.country && <small className="text-danger">{errors.country}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["state"] = el)}>
                    <label className="form-label">State</label>
                    <Select
                      name="state"
                      options={[{ value: "", label: "Select a State" }, ...permStates]}
                      value={
                        formData.state && formData.state !== "0"
                          ? permStates.find((s) => String(s.value) === String(formData.state))
                          : null
                      }
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        console.log("Perm State selected:", value)
                        handleChangeWithValidation({
                          target: {
                            name: "state",
                            value,
                          },
                        })
                      }}
                      placeholder="Select a State"
                      isDisabled={formData.useTempAddress}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.state && <small className="text-danger">{errors.state}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["city"] = el)}>
                    <label className="form-label">City</label>
                    <Select
                      name="city"
                      options={[{ value: "", label: "Select a City" }, ...permCities]}
                      value={
                        formData.city && formData.city !== "0"
                          ? permCities.find((c) => String(c.value) === String(formData.city))
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "city",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      isDisabled={formData.useTempAddress}
                      placeholder="Select a City"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.city && <small className="text-danger">{errors.city}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["pincode"] = el)}>
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      placeholder="Enter pincode"
                      className="form-control"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                      // pattern="[0-9]{6}"
                      maxLength="6"
                      inputMode="numeric"
                    />
                    {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
                  </div>
                </div>

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Other Information
                </h6>
                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["adName"] = el)}>
                    <label className="form-label">
                      Ad Name 
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Ad Name"
                      name="adName"
                      value={formData.adName}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.adName && <small className="text-danger">{errors.adName}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["adSet"] = el)}>
                    <label className="form-label">
                      Ad Set 
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Ad Set"
                      name="adSet"
                      value={formData.adSet}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.adSet && <small className="text-danger">{errors.adSet}</small>}
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["campaignName"] = el)}>
                    <label className="form-label">
                      Campaign Name 
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Campaign Name"
                      name="campaignName"
                      value={formData.campaignName}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.campaignName && <small className="text-danger">{errors.campaignName}</small>}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["leadSource"] = el)}>
                    <label className="form-label">
                      Lead Source <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      name="leadSource"
                      options={[
                        { value: "Facebook", label: "Facebook" },
                        { value: "Instagram", label: "Instagram" },
                        { value: "Twitter", label: "Twitter" },
                        { value: "Google", label: "Google" }, // Added Google
                        { value: "Referral", label: "Referral" }, // Added Referral
                        { value: "Website", label: "Website" }, // Added Website
                        { value: "Other", label: "Other" }, // Added Other
                      ]}
                      value={
                        formData.leadSource
                          ? {
                              value: formData.leadSource,
                              label: formData.leadSource,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "leadSource",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Lead Source"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.leadSource && <small className="text-danger">{errors.leadSource}</small>}
                  </div>
                  <div className="col-xl-4 mb-3">
  <label className="form-label">Call Conduct</label>

  <Select
    name="callConduct"
    options={callConductOptions}

    value={callConductOptions.find(
      (option) => option.value === formData.callConduct
    )}

    onChange={(selectedOption) =>
      setFormData((prev) => ({
        ...prev,
        callConduct: selectedOption?.value || "",
      }))
    }

    placeholder="Select Call Conduct"

    styles={{
      control: (provided) => ({
        ...provided,
        minHeight: "50px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "4px",
      }),
      indicatorSeparator: () => ({ display: "none" }),
    }}
  />
</div>

           

                  {/* <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["lead_type"] = el)}>
                    <label className="form-label">
                      Priority <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      name="lead_type"
                      options={[
                        { value: "Low", label: "Low" },
                        { value: "Medium", label: "Medium" },
                        { value: "High", label: "High" },
                      ]}
                      value={
                        formData.lead_type
                          ? {
                            value: formData.lead_type,
                            label: formData.lead_type,
                          }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "lead_type",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Priority"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.lead_type && (
                      <small className="text-danger">{errors.lead_type}</small>
                    )}
                  </div> */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["lead_type"] = el)}>
                    <label className="form-label">
                      Lead Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      name="lead_type"
                      options={[
                        { value: "Hot", label: "Hot" },
                        { value: "Warm", label: "Warm" },
                        { value: "Cold", label: "Cold" },
                      ]}
                      value={
                        formData.lead_type
                          ? {
                              value: formData.lead_type,
                              label: formData.lead_type,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "lead_type",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Lead Type"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.lead_type && <small className="text-danger">{errors.lead_type}</small>}
                  </div>
                </div>

                <div className="row">
                <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["lead_status"] = el)}>
                    <label className="form-label">
                      Status <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      name="lead_status"
                      options={[
                        { value: "New", label: "New" },
                        { value: "Assigned", label: "Assigned" },
                        { value: "Contacted", label: "Contacted" }, // Added Contacted
                        { value: "Qualified", label: "Qualified" }, // Added Qualified
                        { value: "Unqualified", label: "Unqualified" }, // Added Unqualified
                        { value: "Converted", label: "Converted" },
                        { value: "Not Converted", label: "Not Converted" },
                        { value: "Completed", label: "Completed" },
                      ]}
                      value={formData.lead_status ? { value: formData.lead_status, label: formData.lead_status } : null}
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "lead_status",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Status"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.lead_status && <small className="text-danger">{errors.lead_status}</small>}
                  </div>
                  <div className="col-xl-8 mb-3" ref={(el) => (fieldRefs.current["comment"] = el)}>
                    <label className="form-label">Comment</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Enter comment"
                      name="comment"
                      value={formData.comment || ""}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.comment && <small className="text-danger">{errors.comment}</small>}
                  </div>
                </div>

                <Button variant="primary" type="submit" disabled={isLoading || fetching}>
                  {isLoading || fetching ? (
                    <>
                      <Loader size="sm" />
                      <span className="ms-2">{leadId ? "Updating..." : "Saving..."}</span>
                    </>
                  ) : leadId ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddLead;
